import { memo } from 'react';

/**
 * SkipToContent - Enhanced skip link for accessibility
 * Allows keyboard users to skip navigation and go directly to main content
 */
const SkipToContent = () => {
	return (
		<a href="#main-content" className="skip-link">
			Skip to main content
		</a>
	);
};

export default memo(SkipToContent);
